import React from 'react';
import { IPageContentTitleProps } from './PageContentTitle.types';
import styles from './PageContentTitle.module.css';

export const PageContentTitle: React.FC<IPageContentTitleProps> = ({ children }: IPageContentTitleProps) => {
  return <h3 className={styles.pageContentTitle}>{children}</h3>;
};
